module.exports = __webpack_public_path__ + "img/twitter.22ea44de.svg";